module.exports = __webpack_public_path__ + "static/img/JM@2x.db1ebbec.jpg";